<!--
 * @Author: your name
 * @Date: 2021-02-01 14:23:05
 * @LastEditTime: 2022-12-08 10:36:12
 * @LastEditors: 逐梦的风很轻 1114532270@qq.com
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/views/product-detail/component/RecommandProductMutipleSizeContent/index.vue
-->
<style scoped lang="sass">
.app_container_full
  display: flex
  flex-direction: column
  height: calc(var(--vh, 1vh) * 100 - 66px)

.title
  // position: fixed
  // margin-top: -85PX
  padding: 10px 40px
  text-overflow: ellipsis
  white-space: nowrap
  border-radius: 18PX 18PX 0 0
  border-bottom: 1px solid #e8e8e9
  width: 100vw
  height: 70PX
  line-height: 48PX
  font-size: 16px
  text-align: center
  overflow: hidden
  background: #fff
  z-index: 2

.pic_container
  height: 200px
  width: 250px
  margin: auto
  margin-top: 10px
  margin-bottom: 20px

.text_introduction
  padding: 0 16px
  margin-bottom: 10px
  font-size: 12px
  font-weight: 400
  line-height: 18px
  color: #334455
  opacity: 0.75

  .contains,
  .spicy
    margin-bottom: 10px

.img
  height: 100%
  width: 100%
  object-fit: cover

.content
  flex: 1
  overflow: auto

  .mutiple_size_container
    padding: 0 15PX

.footer
  padding: 20PX 0
  display: flex
  justify-content: center
  width: 100vw
  border-top: 1px solid #e8e8e9
  background: #fff
  z-index: 2

  .footer_button
    width: calc(100vw - 30PX)

  .adjustMoney
    .mark
      margin-left: 3px
      letter-spacing: 1px
</style>

<template lang="pug">
.app_container_full
  .title.b {{ newProduct.name }}
  .content(ref="comboContentDiv")
    .pic_container
      img.img(:src="getLocalizedProductImage(newProduct)")
    div
      .text_introduction {{ newProduct.description }}
      .text_introduction
        contain-tags.contains(:containTags="newProduct.containsTags" :seafoodOrigin="newProduct.seafoodOrigin")
        spicy.spicy(
          v-if="newProduct.id"
          :spiceLevel="newProduct.spiceLevel"
          :tags="newProduct.tags"
        )
      mutiple-size.mutiple_size_container(
        v-if="show && newProduct.sizeSettings && newProduct.sizeSettings.mutipleSize"
        ref="mutipleSize"
        :filterOtherOption = "filterOtherOption"
        :item-list="mutipleSizeSettingsList"
        @choosedItem="choosedRecommandItem"
      )
      ComboCollapseBox(ref="ComboCollapseBox" :modifications="newProduct.modifications" :passList="passList")

  .footer(v-if="!isUpgradeProducts || modificationsLength || show && newProduct.sizeSettings && newProduct.sizeSettings.mutipleSize")
    van-button.footer_button(
      size="large"
      type="primary"
      @click="handleClick"
    ) {{ t('done', 'DONE') }}

  .footer(v-else)
    van-button.footer_button(
      v-if="!isUpgradeProducts"
      size="large"
      type="primary"
      @click="cloneDialog"
    ) {{ t('select', 'SELECT') }}

    van-button.footer_button(
      v-else
      size="large"
      type="primary"
      @click="addUpgradeProductDialog"
    )
      .adjustMoney
        span {{ t('upgrade_for', 'UPGRADE FOR') }}
        span.mark {{ newProduct.price < 0 ? '-' : '+' }}$
        span.just_price {{ parseFloat(newProduct.price) < 0 ? -parseFloat(newProduct.price) : newProduct.price | fix }}

</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import MutipleSize from './../MutipleSize'
import ComboCollapseBox from './../ComboCollapseBox'
import Spicy from './../Spicy'
import ContainTags from './../ContainTags'
import { getLocalizedField, t, tParams } from '@/utils/language'
import { formatDecimalNumber } from '@/utils/currency'
import { isOptionHidden, resolveEditCollapse, sectionLimitKind, sectionLowerBound, sectionMaxOption } from '../../utils/modSectionState'
import { calcSelectedTotal } from '../../utils/modOptionNumber'
import { limitWrongCopy, rangeWrongCopy } from '../../utils/sectionDesc'
import { mapState } from 'vuex'

@Component({
  filters: {
    fix (val) {
      return formatDecimalNumber(val)
    }
  },

  components: {
    MutipleSize,
    ComboCollapseBox,
    Spicy,
    ContainTags
  },

  props: {
    product: {
      type: Object
    },
    show: Boolean, // Whether to display the pop-up component   // 是否显示该弹窗组件
    isUpgradeProducts: {
      type: Boolean,
      default: false
    },
    isCombo: Boolean,
    isPosEnable: Boolean,
    isEdit: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapState({
      currentLanguage: state => state.language?.currentLanguage,
    }),
    mutipleSizeSettingsList() {
      return this.newProduct.sizeSettings?.settings ?? []
    },

    modificationsLength () {
      return this.newProduct?.modifications?.length ?? 0
    },

    filterOtherOption() {
      return !!((this.isCombo & this.isPosEnable))
    }
  },

  watch: {
    show: {
      immediate: true,
      async handler (val) {
        this.newProduct = JSON.parse(JSON.stringify(this.product))

        await this.$nextTick()
        if (this.product?.modifications?.length ?? 0) {
          this.$refs.ComboCollapseBox._getProductRequiredModificationsIndex()
        }

        this.newProduct.modifications = this.newProduct.modifications.map(item => {
          // 只有改单才把选过的组摆开；第一次打开时商家配的"默认折叠"说了算。
          // Only a cart-line refill reopens picked sections.
          const collapse = resolveEditCollapse(item, { fromCart: this.isEdit === true })

          if (item.id !== -1 || (item.id === -1 && item.isCombo)) {
            return {
              ...item,
              collapse
            }
          } else {
            return {
              ...item,
              collapse,
              options: item.options.map(each => {
                return {
                  ...each,
                  checked: false
                }
              })
            }
          }
        })

        // Initialize choosedItemInfo when the component is not displayed
        // 组件不显示时，初始化 choosedItemInfo
        if (val) {
          this.$refs.ComboCollapseBox._defaultChoose()
          this._initChoosedItemInfo()
        } else {
          this.newProduct = []
          this.choosedItemInfo = {
            price: null,
            name: null,
            default: null,
            shortName: null,
            index: null,
          }
        }
      }
    }
  }
})

class RecommandProductMutipleSizeContent extends Vue {
  t(key, fallback) {
    const _lang = this.$lang // eslint-disable-line no-unused-vars
    return t(key, fallback)
  }

  newProduct = null
  choosedItemInfo = {
    price: null,
    name: null,
    default: null,
    shortName: null,
    index: null,
  }

  modificationList = []

  passList = []

  /**
   * Get localized product image
   * 获取本地化的产品图片
   */
  getLocalizedProductImage(product) {
    if (!product) return ''
    const _lang = this.currentLanguage // eslint-disable-line no-unused-vars
    return getLocalizedField(product, 'image') || product.image || ''
  }

  mounted () {
    this._setVh()
  }

  handleClick() {
    this._validateRequiredModifications()
    const isPassValidate = this.newProduct?.modifications.filter(item => item.wrong && !item.options.every(option => option.unShow)).length === 0
    if (isPassValidate) {
      this.passList = []
      this.$emit('product', this.newProduct)
      this.$emit('chooseRecommandMutipleSize', { selectSize: this.choosedItemInfo, product: this.newProduct })
    } else {
      this.$refs.ComboCollapseBox._scrollToErrorItem()
    }
  }

  // Close component
  // 关闭组件
  cloneDialog() {
    this.$emit('chooseProductIntroduction')
  }

  choosedRecommandItem(item) {
    this.choosedItemInfo = item
  }

  // Options before pre filling in the edit product scenario
  // edit 商品场景下，预填写之前的选项
  _setDefault() {
    this.$refs.ComboCollapseBox._defaultChoose()
    this._getChoosedRecommandProductMutipleSizeInfo()

    // scroll to top
    if (this.$refs.comboContentDiv) {
      this.$refs.comboContentDiv.scrollIntoView()
      this.$refs.comboContentDiv.scrollTop = 0
    }
  }

  _initChoosedItemInfo() {
    if (!this.newProduct?.sizeSettings?.mutipleSize) return
    let { settings } = this.newProduct.sizeSettings
    settings = settings?.map((item, index) => {
      return {
        index,
        ...item,
        price: parseFloat(item.price).toFixed(2)
      }
    })
    const defaultItem = settings?.find(item => item.default)
    if (defaultItem) {
      this.choosedItemInfo = settings[defaultItem.index]
      this.$refs.mutipleSize.choosedIndex = defaultItem.index
    }
  }

  _validateRequiredModifications() {
    // Form validation. If there is an option that fails, the corresponding prompt text will be displayed and the first error will be jumped to
    // 表单验证，若有没通过的选项，显示对应提示文字，并跳转到第一个错误
    this.newProduct = {
      ...this.newProduct,
      modifications: this.newProduct.modifications.map((item) => {
        // 判据同 index.vue 的 _validateRequiredModifications：这一格自己的内容，
        // 不是「在不在 passList 里」——required 组被 default 预选满足、或改单回填
        // 已经选够时，从来没走过 getCheckNum 也该放行。passList 机制本身不动，
        // 只是这道加购闸门不再问它。
        if (item.type === 'required' && !item.options.every(isOptionHidden) && sectionLowerBound(item) - calcSelectedTotal(item.options) > 0) {
          // `limitType` 归一化成 range / limit / exactly 三选一（见 utils/sectionLimit 的
          // `sectionLimitKind`）：**认不出来的值一律当 `exactly`**（owner 2026-08-10 裁定）。
          // 以前这条链直接比裸 `limitType`，没有 `else` —— 没写 limitType 的必选组
          // 一条校验都不跑，一样都不选照样加进购物车，屏幕上却写着「Required」。
          const limitKind = sectionLimitKind(item)
          let wrongMsg
          if (!item.options.every(option => option.unShow)) {
            if (limitKind === 'exactly') {
              // 念的是这一组真正被校验的那个数（有效上限，见 utils/sectionLimit.js），
              // 不是裸 minOption —— 两个键都没写出数时裸值会念成 `Select  (Required)`。
              // 这一支在 `item.type === 'required'` 里，所以有效上限一定是个正整数
              // （可选的 exactly 组是 NO_CAP，但它不做校验，也就没有这句提示）。
              wrongMsg = tParams('select_n_required', 'Select {n} (Required)', { n: sectionMaxOption(item) })
            } else if (limitKind === 'range') {
              // 两个数各自要「念得出」才念，唯一实现见 utils/sectionDesc 的 rangeCopy
              wrongMsg = rangeWrongCopy(item)
            } else if (limitKind === 'limit') {
              // 这一组的校验拦的是「一样都没选」，所以念「至少选 1 样」——
              // 以前念 `Select up to {minOption}`，而那个字段在 limit 组通常是 0 或空
              wrongMsg = limitWrongCopy()
            }
          }
          return {
            ...item,
            wrong: wrongMsg
          }
        } else {
          return {
            ...item,
          }
        }
      })
    }
  }

  // When editing product, select the result of the last size
  // edit product 时，选中上次 size 的结果
  _getChoosedRecommandProductMutipleSizeInfo() {
    const activeChoosedItemInfo = this.newProduct?.selectSize?.name
    if (activeChoosedItemInfo) {
      const choosedItemIndex = this.newProduct.sizeSettings.settings.findIndex(item => item.name === this.newProduct?.selectSize?.name)
      this.$refs.mutipleSize._setChoosedIndex(choosedItemIndex)
    }
  }

  // Click OK to add and transfer the unique subscript to the parent component
  // 点击确定添加，向父组件传唯一下标
  addUpgradeProductDialog() {
    this.$emit('chooseUpgradeProduct', this.newProduct.index, this.isUpgradeProducts)
    this.cloneDialog()
  }

  _setVh() {
    document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`)
  }
}

export default RecommandProductMutipleSizeContent
</script>
